import { BrandItem, BrandItemLink } from './styles';
import React, { forwardRef } from 'react';
import { SponsoredBrandItemProps } from './sponsored-brand-item';
import { withPointerUpHandling } from 'common/hocs/with-pointer-up-handling';

export const BrandsItem = forwardRef<HTMLDivElement, SponsoredBrandItemProps>((props, ref) => {
  const { brand, id } = props;

  return (
    <BrandItem ref={ref}>
      <BrandItemLink href={brand.targetUrl}>
        <picture>
          <img src={brand.pictureUrl} alt={`Brand ${id}`} />
        </picture>
      </BrandItemLink>
    </BrandItem>
  );
});

export const SponsoredBrandItemWithClickEvent = withPointerUpHandling(BrandsItem);
